import { Dropdown, MenuProps } from 'antd';
import cls from 'classnames';
import { useCallback, useMemo } from 'react';

import styles from './index.module.scss';
import arrowDownIcon from '../../../assets/Edit/arrowDown.png';
import { CFG_SCALE_STEPS_MAP } from '../../../constants/image';
import { IImageModel, useImageModels } from '../../../hooks';
import { useAppSelector, useAppDispatch } from '../../../state';
import { setImgConfig, setImgPreviewExtra, setModelType } from '../../../state/image';
import { track } from '../../../track';
import { LocalImage } from '../../Image';

export function ModelSelect({ source }: { source: string }) {
  const { models } = useImageModels();
  const { web_preview_extra, avatar_style_id_list } = useAppSelector(
    (state) => state.image.imgConfig
  );

  const selectedModel = useMemo(
    () =>
      web_preview_extra?.img_model_id
        ? models.find((model) => model.id === web_preview_extra.img_model_id)
        : models[0],
    [web_preview_extra, models]
  );

  const dispatch = useAppDispatch();

  const onSelectModel = useCallback(
    (model: IImageModel) => {
      if (web_preview_extra?.img_model_id === model.id) return;

      track.send('image_model_choice_click', source, {
        image_model_id: model.id,
      });

      dispatch(setModelType(model.type));
      // 切换模型时需要清空画风
      if (avatar_style_id_list && avatar_style_id_list.length > 0) {
        dispatch(
          setImgPreviewExtra({
            img_model_id: model.id,
            style_img_url: undefined,
          })
        );
      } else dispatch(setImgPreviewExtra({ img_model_id: model.id }));
      dispatch(setImgConfig({ avatar_style_id_list: [] }));

      if (CFG_SCALE_STEPS_MAP[model.type]) {
        const cfg_scale = CFG_SCALE_STEPS_MAP[model.type].mid;
        dispatch(setImgPreviewExtra({ cfg_scale }));
      }
    },
    [web_preview_extra?.img_model_id, source, dispatch, avatar_style_id_list]
  );

  const items: MenuProps['items'] = useMemo(
    () =>
      models.map((item) => ({
        key: item.type,
        onClick: () => onSelectModel(item),
        label: (
          <div className={styles.item}>
            <img className={styles.logo} src={item.icon} />
            <p>{item.name}</p>
          </div>
        ),
      })),
    [models, onSelectModel]
  );

  return (
    <Dropdown menu={{ items }} overlayClassName={styles.dropdown}>
      <div className={cls(styles.selectBtn)}>
        <img className={styles.logo} src={selectedModel?.icon} />
        <p>{selectedModel?.name}</p>
        <LocalImage className={styles.arrow} src={arrowDownIcon} />
      </div>
    </Dropdown>
  );
}
